import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "p-grid p-m-0 p-jc-center",
  style: {"overflow":"auto"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Message = _resolveComponent("Message")
  const _component_NameCard = _resolveComponent("NameCard")
  const _component_KnCron = _resolveComponent("KnCron")
  const _component_EventsCard = _resolveComponent("EventsCard")
  const _component_KpiCard = _resolveComponent("KpiCard")
  const _component_AddActionDialog = _resolveComponent("AddActionDialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-m-0" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.selectedAlert.name), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          disabled: _ctx.buttonDisabled,
          onClick: _ctx.handleSubmit
        }, null, 8, ["disabled", "onClick"]),
        _createVNode(_component_Button, {
          icon: "pi pi-times",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.closeTemplateConfirm
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_1, [
      (_ctx.expiredCard)
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 0,
            class: "p-m-2",
            severity: "warn",
            closable: true,
            style: _ctx.alertDescriptor.styles.message
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('kpi.alert.expiredWarning')), 1)
            ]),
            _: 1
          }, 8, ["style"]))
        : _createCommentVNode("", true),
      _createVNode(_component_NameCard, {
        selectedAlert: _ctx.selectedAlert,
        listeners: _ctx.listeners,
        onValueChanged: _ctx.updateAlert,
        vcomp: _ctx.v$.selectedAlert
      }, null, 8, ["selectedAlert", "listeners", "onValueChanged", "vcomp"]),
      (_ctx.selectedAlert?.frequency)
        ? (_openBlock(), _createBlock(_component_KnCron, {
            key: 1,
            class: "p-m-2",
            frequency: _ctx.selectedAlert.frequency,
            onTouched: _cache[1] || (_cache[1] = ($event: any) => (_ctx.touched = true)),
            onCronValid: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCronValid($event)))
          }, null, 8, ["frequency"]))
        : _createCommentVNode("", true),
      _createVNode(_component_EventsCard, {
        selectedAlert: _ctx.selectedAlert,
        onValueChanged: _ctx.updateAlert
      }, null, 8, ["selectedAlert", "onValueChanged"]),
      (_ctx.isListenerSelected && _ctx.actionList?.length > 0)
        ? (_openBlock(), _createBlock(_component_KpiCard, {
            key: 2,
            selectedAlert: _ctx.selectedAlert,
            kpiList: _ctx.kpiList,
            actionList: _ctx.actionList,
            onShowDialog: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onShowActionDialog($event))),
            onKpiLoaded: _ctx.updateKpi,
            onTouched: _cache[4] || (_cache[4] = ($event: any) => (_ctx.touched = true))
          }, null, 8, ["selectedAlert", "kpiList", "actionList", "onKpiLoaded"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_AddActionDialog, {
      dialogVisible: _ctx.isActionDialogVisible,
      kpi: _ctx.kpi,
      selectedAction: _ctx.selectedAction,
      actionList: _ctx.actionList,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isActionDialogVisible = false)),
      onSave: _ctx.onActionSave
    }, null, 8, ["dialogVisible", "kpi", "selectedAction", "actionList", "onSave"])
  ], 64))
}